<div class="row text-center">
  <div class="col-12">
    <h2>
      {{data.heading | translate}}
    </h2>
  </div>
</div>

<div class="column justify-content-between" *ngFor="let option of data.options; let last = last">
  <button color="primary" mat-button class="w-100" [mat-dialog-close]="option.returnValue">
    {{option.text | translate}}
  </button>
  <mat-divider *ngIf="!last" class="m-1"></mat-divider>
</div>

<div class="row justify-content-end">
  <button color="warn" mat-button [mat-dialog-close]="null">
    {{'dialogs.export_dialog.actions.close' | translate}}
  </button>
</div>

